import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Msg } from '../i18n-review/client/Msg';

/**
 * Shown when the main layout tree hits an error boundary (keeps chrome/providers
 * mounted when possible — boundary wraps LayoutContent only).
 */
export function LayoutPageErrorFallback() {
  return (
    <div
      className="min-h-[40vh] flex flex-col items-center justify-center px-4 py-12 text-center"
      role="alert"
    >
      <div className="max-w-md rounded-2xl border border-jc-border bg-jc-elevated px-6 py-8 shadow-sm">
        <h1 className="text-lg font-semibold text-jc-ink mb-2">
          <Msg
            id="layoutErrorFallback.title"
            defaultMessage="Something went wrong"
            description="Title when a page section fails to render"
          />
        </h1>
        <p className="text-sm text-jc-muted mb-6">
          <Msg
            id="layoutErrorFallback.body"
            defaultMessage="Please try reloading the page. If the problem continues, we have been notified."
            description="Body when a page section fails to render"
          />
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            className="rounded-xl bg-jc-cta text-white px-4 py-2.5 text-sm font-medium hover:bg-jc-cta-hover"
            onClick={() => {
              if (typeof window !== 'undefined') window.location.reload();
            }}
          >
            <Msg
              id="layoutErrorFallback.reload"
              defaultMessage="Reload page"
              description="Button to reload after an error"
            />
          </button>
          <a
            href="/"
            className="rounded-xl border border-jc-border bg-jc-page px-4 py-2.5 text-sm font-medium text-jc-ink hover:bg-jc-elevated"
          >
            <Msg
              id="layoutErrorFallback.home"
              defaultMessage="Go to home"
              description="Link to home after an error"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
